import React from 'react';
import whatsapp from "../../assets/images/whatsapp_mini.png";
import email from "../../assets/images/email_mini.png";
import location from "../../assets/images/pin_mini.png";
import "./style.css";

export default function ContactData() {
    return (
        <address className="flex grid text-left not-italic">
            <p>
                <img className="contact-logo" src={location} alt="" aria-hidden="true" />&nbsp;&nbsp;&nbsp;
                <a className="text-black" href="https://www.google.com/maps?q=balbastro+2588,+ciudad+autonoma+de+buenos+aires,+buenos+aires,+argentina" rel="noopener noreferrer" target="_blank" aria-label="Ver ubicación en Google Maps">Balbastro 2588, Ciudad Autónoma de Buenos Aires</a>
            </p>
            <p className="pt-3">
                <img className="contact-logo" src={whatsapp} alt="" aria-hidden="true" />&nbsp;&nbsp;&nbsp;
                <a className="text-black" href="https://wa.me/5491151494430?text=Hola%2C+queria+consultar+el+precio+de+" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp Carlos">+549 (011) 5149-4430 (Carlos)</a> <span className="mobile-hidden">/</span><br className='mobile-only' /><span className='mobile-only inline-block'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><a className="text-black" href="https://wa.me/5491138298971?text=Hola%2C+queria+consultar+el+precio+de+" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp Sergio">+549 (011) 3829-8971 (Sergio)</a>
            </p>
            <p className="pt-3">
                <img className="contact-logo" src={email} alt="" aria-hidden="true" />&nbsp;&nbsp;&nbsp;
                <a className="text-black" href="mailto:marmolesgranitos@gmail.com" aria-label="Enviar email">marmolesgranitos@gmail.com</a>
            </p>
        </address>
    );
}
